import { createContext } from "react";

interface ProgressBarContextInterface {
	isPageLoaded: boolean;
	setIsPageLoaded: (a: boolean) => void;
	startProgressBarLoading: (a?: string) => void;
	resetProgressBar: (args?: { loadingPageSecion: boolean }) => void;
	loadedSection: string;
	setLoadedSection: (a: string) => void;
	setProgressBarStyles: (a: any) => void;
}

const ProgressBarContext = createContext<ProgressBarContextInterface>({
	isPageLoaded: false,
	setIsPageLoaded: () => {},
	startProgressBarLoading: () => {},
	resetProgressBar: () => {},
	loadedSection: "",
	setLoadedSection: () => {},
	setProgressBarStyles: () => {}
});

ProgressBarContext.displayName = "ProgressBarContext";

export default ProgressBarContext;
